import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemIntegrationStatus = ({ integrations }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'connected':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return 'CheckCircle2';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  const formatLatency = (ms) => {
    if (ms < 100) return `${ms}ms`;
    if (ms < 1000) return `${ms}ms`;
    return `${(ms / 1000)?.toFixed(1)}s`;
  };

  return (
    <div className="bg-card rounded-xl border-2 border-border p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
        <Icon name="Plug" size={24} color="var(--color-primary)" />
        <h2 className="text-lg md:text-xl font-semibold text-foreground">
          System Integration Status
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {integrations?.map((integration) => (
          <div
            key={integration?.id}
            className="bg-muted rounded-lg p-4 border-2 border-border hover:border-primary transition-all duration-250"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <Icon
                  name={integration?.icon}
                  size={20}
                  color="var(--color-primary)"
                />
                <h3 className="text-sm md:text-base font-semibold text-foreground">
                  {integration?.name}
                </h3>
              </div>
              <Icon
                name={getStatusIcon(integration?.status)}
                size={20}
                color={integration?.status === 'connected' ? 'var(--color-success)' : integration?.status === 'warning' ? 'var(--color-warning)' : 'var(--color-error)'}
              />
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="caption text-muted-foreground">Status</span>
                <span className={`caption font-medium ${getStatusColor(integration?.status)}`}>
                  {integration?.status?.charAt(0)?.toUpperCase() + integration?.status?.slice(1)}
                </span>
              </div>

              <div className="flex items-center justify-between">
                <span className="caption text-muted-foreground">Latency</span>
                <span className="caption font-medium text-foreground data-text">
                  {formatLatency(integration?.latency)}
                </span>
              </div>

              <div className="flex items-center justify-between">
                <span className="caption text-muted-foreground">Last Sync</span>
                <span className="caption font-medium text-foreground">
                  {integration?.lastSync}
                </span>
              </div>

              {integration?.dataStreams && (
                <div className="pt-2 border-t border-border">
                  <span className="caption text-muted-foreground">Active Streams</span>
                  <div className="flex flex-wrap gap-1 mt-1">
                    {integration?.dataStreams?.map((stream, index) => (
                      <span
                        key={index}
                        className="caption px-2 py-0.5 bg-background rounded-md text-foreground"
                      >
                        {stream}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemIntegrationStatus;